module.exports = __webpack_public_path__ + "static/media/conor.a35434da.png";